module.exports = __webpack_public_path__ + "header-bg.343c47ab7ee41ea96b70.png";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/header-bg.png
// module id = ../../../../../src/assets/header-bg.png
// module chunks = 2